import { stringify } from 'qs';
import { CampaignListRow } from './columns';

export const REDESIGN_VERSION_CUTOFF = 3;

type PathInfo = { pathname: string; search?: string };
type ReportType = CampaignListRow['reportType'];

const getCampaignSubpath = (
  campaignType: CampaignListRow['campaignType'],
  lciVersion: CampaignListRow['lciVersion'],
  reportType: ReportType
) => {
  if (campaignType === 'cpg') {
    return '/cpg';
  }

  return lciVersion >= REDESIGN_VERSION_CUTOFF &&
    reportType !== 'custom_recurring'
    ? '/v3'
    : '';
};

export const getCampaignPath = (
  campaignId: CampaignListRow['campaignId'],
  campaignType: CampaignListRow['campaignType'],
  reportType: CampaignListRow['reportType'],
  lciVersion: CampaignListRow['lciVersion'],
  reportId?: CampaignListRow['reportId'],
  partnerName?: string,
  reportGroup?: string
): PathInfo => {
  const pathname = `/campaigns${getCampaignSubpath(campaignType, lciVersion, reportType)}/${campaignId}`;

  const getSearchString = () => {
    switch (reportType) {
      case 'custom': {
        return `?report_id=${reportId}&type=custom_report`;
      }
      case 'custom_recurring': {
        return `?channel_partner=${partnerName}&report_group=${reportGroup}&type=partner_report`;
      }
      default: {
        return ['?', stringify({ channel: partnerName })].join('');
      }
    }
  };

  return {
    pathname,
    search: getSearchString(),
  };
};
